<template>
    <div class="col-md-9">
        <div class="pages__title-holder mb-3">
            <h1 class="pages__title m-0">Testimonials</h1>
            <div class="d-flex align-items-center">
                <a href="/admin/panel/testimonials/create" class="btn btn_golden mr-1"><span>+ Add New</span></a>
            </div>
        </div>
        <div class="pages__table">
            <div class="pages__top">
                <div class="image">
                    Author Name
                </div>
                <div class="route">
                    Author Position
                </div>
                <div class="slug">
                    Content
                </div>
                <div class="action">
                    Action
                </div>
            </div>
            <ul class="pages__list">
                <li
                    class="pages__line"
                    v-for="(testimonial, index) in testimonials"
                    :key="testimonial.id"
                >
                    <div class="image">
                        {{ testimonial.author_name}}
                    </div>
                    <div class="slug">
                        {{ testimonial.author_position}}
                    </div>
                    <div class="route">
                      {{ testimonial.content}}
                    </div>
                    <div class="action">
                        <div class="action__hold">
                            <a
                                :href="`/admin/panel/testimonials/${testimonial.id}/edit`"
                                class="edit"
                            >
                                <svg width="16" height="16" aria-hidden="true">
                                    <use href="/img/svg/symbol-defs.svg#icon-edit"></use>
                                </svg>
                            </a>
                            <a
                                href="javascript:void(0)"
                                class="delete"
                                @click="openDeleteModal(testimonial.id)"
                            >
                                <svg width="16" height="16" aria-hidden="true">
                                    <use href="/img/svg/symbol-defs.svg#icon-close-9"></use>
                                </svg>
                            </a>
                        </div>
                    </div>
                </li>
            </ul>
        </div>
        <ActionModal
            :modal-id="getCustomModalId('delete',currentTestimonialId)"
            @confirm="deleteItem(currentTestimonialId)"
            :reject-text="`No`"
            :confirm-text="`Yes`"
        >
            <template #body>
                <div class="text-center mb-4">
                    <div class="text-center">
                        <h5 class="title">Are you sure ?</h5>
                        <p>Do you want to delete this testimonial?</p>
                    </div>
                </div>
            </template>
        </ActionModal>
    </div>
</template>


<script>
import ActionModal from "../../Common/ActionModal.vue";
import ModalHandler from "../../../mixins/ModalHandler";
import AdminPanelService from "../../../services/AdminPanelService";

export default {
    name: 'Testimonials',
    components: {ActionModal},
    mixins: [ModalHandler],
    data() {
        return {
            testimonials: [],
            currentTestimonialId: null,
        }
    },
    methods: {
        async fetchTestimonials() {
            try {
                const { data: response } = await AdminPanelService.fetchListOfTestimonials()
                this.testimonials = response

            } catch (e) {
                console.error(e)
            }
        },
        openDeleteModal(id) {
            this.currentTestimonialId = id
            this.$nextTick(()=> {
                this.showCustomModal('delete', id)
            })
        },
        async deleteItem(itemId) {
            try {
                await AdminPanelService.deleteTestimonials(itemId)
                this.testimonials = this.testimonials.filter(item => item.id !== itemId)
                this.$showSuccessMessage('The testimonial was deleted!')
            } catch (e) {
                console.error(e)
                this.$showErrorMessage('The testimonial was not deleted. Please try again')
            }
        },
        getNameOfAvatar(photo) {
            return photo ? `/uploads/${photo}` : "/img/svg/avatar.svg";
        },
    },
    mounted() {
        this.fetchTestimonials()
    }
}

</script>


<style scoped>

</style>
